
import React from 'react';
import { getDctosGradient } from '@/lib/dctos-config';

interface CustomDotProps {
  cx?: number;
  cy?: number;
  payload?: {
    name: string;
    color: string;
  };
}

const CustomDot: React.FC<CustomDotProps> = ({ cx, cy, payload }) => {
  if (!cx || !cy || !payload) return null;
  
  const gradientId = `gradient-${payload.name}-${cx}-${cy}`;
  const gradient = getDctosGradient(payload.name as 'D' | 'C' | 'T' | 'O' | 'S') || ['#94A3B8', '#64748B'];
  
  return (
    <g>
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={gradient[0]} />
          <stop offset="100%" stopColor={gradient[1]} />
        </linearGradient>
      </defs>
      {/* White ring - outer circle */}
      <circle 
        cx={cx} 
        cy={cy} 
        r={7.5} 
        fill="white" 
        stroke={`url(#${gradientId})`} 
        strokeWidth={2.5} 
      />
      {/* Inner gradient circle */}
      <circle 
        cx={cx} 
        cy={cy} 
        r={5} 
        fill={`url(#${gradientId})`} 
      />
    </g>
  );
};

export default CustomDot;
